import { useContext } from 'react';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { isHighDemandModelId } from './highDemandVehicle.constants';

export const useIsHighDemandVehicle = (): boolean => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  return isHighDemandModelId(vehicle?.modelId);
};
